export function getCurrentLanguageFromPath() {
    let currentLanguage: string;

    try {
        const path = window.location.pathname;
        const pathArr = path.split('/');
        const ISO_LANGUAGE_CODE_REGEX = /^[a-z]{2}(-[A-Z]{2})?$/;
        if (Array.isArray(pathArr) && pathArr.length > 1 && pathArr[1].match(ISO_LANGUAGE_CODE_REGEX)) {
            currentLanguage = pathArr[1];
        } else {
            currentLanguage = 'en';
        }
    } catch (error) {
        console.error(error);
        currentLanguage = undefined;
    }
    return currentLanguage;
}
